<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card style="margin-bottom:10px">
        <v-card-title class="greyk lighten-4k">
          <h3>Bank Transactions</h3>

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn color="success" @click="exportAllBanktran()" v-on="on">Excel</v-btn>
            </template>
            <span>Export all banktran this term to excel</span>
          </v-tooltip>-->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
        </v-card-title>
        <v-btn color="success" @click="showBt=!showBt" class="elevation-1">
          <v-icon>add</v-icon>Add Bank Transaction
        </v-btn>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-data-table
                :headers="bank_trans_headers"
                :items="banktrans"
                class="elevation-0"
                :search="search"
                :loading="btloading"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">{{ props.index + 1 }}</td>
                  <td
                    class="text-xs-center"
                  >{{ props.item.bankacc&&props.item.bankacc.bank_name?props.item.bankacc.bank_name+' ('+props.item.bankacc.acc_num+')':'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.tran_type }}</td>
                  <td class="text-xs-center">{{ props.item.amount | toCurrency }}</td>
                  <td class="text-xs-center">{{ props.item.tdate}}</td>
                  <td class="text-xs-center">{{ props.item.description }}</td>
                  <td
                    class="text-xs-center"
                  >{{ props.item.recorded_by&&props.item.recorded_by.name?props.item.recorded_by.name:'N/A' }}</td>

                  <td class="text-xs-center">
                    <!-- <v-btn flat icon color="blue" @click="editbanktran(props.item)">
                          <v-icon>edit</v-icon>
                    </v-btn>-->

                    <v-btn flat icon color="pink" @click="deletebanktran(props.item,props.index)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Bank Accounts</h3>

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn color="success" @click="exportAllBanktran()" v-on="on">Excel</v-btn>
            </template>
            <span>Export all banktran this term to excel</span>
          </v-tooltip>-->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search2"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width:40%"
          ></v-text-field>
        </v-card-title>
        <v-btn color="success" @click="showBa=!showBa" class="elevation-1">
          <v-icon>add</v-icon>Add Bank Account
        </v-btn>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-data-table
                :headers="bank_acc_headers"
                :items="bankaccs"
                class="elevation-0"
                :search="search2"
                :loading="baloading"
                :key="c_refreshKey"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">{{ props.index + 1 }}</td>
                  <td class="text-xs-center">{{ props.item.bank_name }}</td>
                  <td class="text-xs-center">{{ props.item.bank_contact }}</td>
                  <td class="text-xs-center">{{ props.item.acc_name }}</td>
                  <td class="text-xs-center">{{ props.item.acc_num }}</td>
                  <td class="text-xs-center">{{ props.item.acc_type }}</td>
                  <td class="text-xs-center">{{ props.item.balance | toCurrency }}</td>

                  <td class="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn flat icon color="blue" @click="editbankacc(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn
                          flat
                          icon
                          color="pink"
                          @click="deletebankacc(props.item,props.index)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!--dialog form to add and edit bank transaction begins-->
      <bn-dialog pers title="Bank Transaction" :show="showBt">
          <template v-slot:header-actions>
          <v-btn @click="showBt=!showBt" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form1">
            <v-autocomplete
              :items="bacts"
              item-text="bname"
              item-value="id"
              label="Bank Account"
              prepend-icon="book"
              v-model="banktran_model.bankacc_id"
              :rules="valid_rules.required"
            />
            <v-autocomplete
              :items="['debit','credit']"
              label="Transaction Type"
              prepend-icon="money"
              v-model="banktran_model.tran_type"
              :rules="valid_rules.required"
            />

            <v-text-field
              label="Amount (GHS)"
              v-model="banktran_model.amount"
              :rules="valid_rules.required"
              prepend-icon="money"
              type="number"
              step="any"
            />

            <v-text-field
              label="Description/Reference"
              prepend-icon="description"
              v-model="banktran_model.description"
              :rules="valid_rules.required"
            />

            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="banktran_model.tdate"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="banktran_model.tdate"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  :rules="valid_rules.required"
                ></v-text-field>
              </template>
              <v-date-picker v-model="banktran_model.tdate" scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(banktran_model.tdate)">OK</v-btn>
              </v-date-picker>
            </v-dialog>

            <v-checkbox
              v-if="banktran_model.tran_type === 'debit' && editedIndex<0"
              label="Record Corresponding Expense"
              v-model="banktran_model.cep"
            />

            <v-autocomplete
              v-if="banktran_model.cep==true"
              :items="exp_ledgeraccs"
              item-text="name"
              item-value="id"
              label="Select Expense Ledger Account"
              prepend-icon="book"
              v-model="banktran_model.expacc"
              :rules="valid_rules.required"
            />
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn class="error" flat @click.stop="showBt=false">Close</v-btn>
          <v-btn class="success" flat @click="savebanktran();">Save</v-btn>
        </template>
      </bn-dialog>

      <!--dialog form to add and edit bank accounts begins-->
      <bn-dialog pers title="Bank Accounts" :show="showBa">
        <template v-slot:header-actions>
          <v-btn @click="showBa=!showBa" icon style="cursor:pointer">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template v-slot:content>
          <v-form ref="form2">
            <v-text-field
              label="Bank Name"
              prepend-icon="description"
              v-model="bankacc_model.bank_name"
              :rules="valid_rules.required"
            />

            <v-text-field
              label="Bank Contact/Address"
              prepend-icon="description"
              v-model="bankacc_model.bank_contact"
            />

            <v-text-field
              label="Acct. Name"
              prepend-icon="description"
              v-model="bankacc_model.acc_name"
              :rules="valid_rules.required"
            />

            <v-text-field
              label="Acct. Number"
              prepend-icon="description"
              v-model="bankacc_model.acc_num"
              :rules="valid_rules.required"
            />

            <v-autocomplete
              :items="['savings','current']"
              label="Account Type"
              prepend-icon="description"
              v-model="bankacc_model.acc_type"
              :rules="valid_rules.required"
            />

            <v-text-field
              label="Current Balance (GHS)"
              prepend-icon="money"
              v-model="bankacc_model.balance"
              :rules="valid_rules.required"
              type="number"
              step="any"
            />
          </v-form>
        </template>

        <template v-slot:footer-actions>
          <v-btn class="error" flat @click.stop="showBa=false">Close</v-btn>
          <v-btn class="success" flat @click="savebankacc();">Save</v-btn>
        </template>
      </bn-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../../../components/Modal";
import { json2excel, excel2json } from "js2excel";
export default {
  layout: "accounts",
  name: "banktrans-view",
  metaInfo() {
    return { title: this.$t("banktrans") };
  },
  components: {
    "bn-dialog": Modal
  },
  data() {
    return {
      editedIndex: -1,
      search: "",
      search2: "",
      showBa: false,
      showBt: false,
      modal: false,
      fm_title: "",
      c_refreshKey: 0,
      valid_rules: {
        required: [v => !!v || "this field is required"]
      },

      banktran_model: {
        bankacc_id: "",
        tran_type: "",
        description: "",
        amount: "",
        tdate: new Date().toISOString().substr(0, 10),
        cdp: false, //corresponding debt payment
        cep: false, //correspoding expense payment
        debt: "",
        expacc: ""
      },
      bankacc_model: {
        bank_name: "",
        bank_contact: "",
        acc_name: "",
        acc_num: "",
        acc_type: "",
        balance: ""
      },

      bank_acc_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "level"
        },
        {
          text: "Bank Name",
          align: "center",
          sortable: false,
          value: "name"
        },
        {
          text: "Bank Contact",
          align: "center",
          sortable: false,
          value: "contact"
        },
        {
          text: "Acct. Name",
          align: "center",
          sortable: false,
          value: "acc_name"
        },
        {
          text: "Acct. No.",
          align: "center",
          sortable: false,
          value: "acc_number"
        },
        {
          text: "Acct. Type",
          align: "center",
          sortable: false,
          value: "acc_type"
        },
        {
          text: "Current Balance",
          align: "center",
          sortable: true,
          value: "c_balance"
        },

        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ],
      bank_trans_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "level"
        },
        {
          text: "Bank Acct.",
          align: "center",
          sortable: false,
          value: "acc_name"
        },
        {
          text: "Trans. Type",
          align: "center",
          sortable: false,
          value: "trans_type"
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount"
        },
        {
          text: "Trans. Date",
          align: "center",
          sortable: false,
          value: "tdate"
        },
        {
          text: "Description/Ref",
          align: "center",
          sortable: true,
          value: "description"
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: true,
          value: "recorded_by.name"
        },

        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "name"
        }
      ]
    };
  },
  mounted() {
    this.$store.dispatch("banktrans/getAll");
    this.$store.dispatch("bankaccs/getAll");
    this.$store.dispatch("ledgeraccs/getAll");
  },
  computed: {
    ...mapGetters({
      bankaccs: "bankaccs/BANKACCS",
      baloading: "bankaccs/BANKACC_LOADING",
      baerrors: "bankaccs/BANKACC_ERROR",

      banktrans: "banktrans/BANKTRANS",
      btloading: "banktrans/BANKTRAN_LOADING",
      bterrors: "banktrans/BANKTRAN_ERROR",

      ledgeraccs: "ledgeraccs/LEDGERACCS",
      exp_ledgeraccs: "expenses/EXPENSE_LEDGERACCS",
      laerrors: "ledgeraccs/LEDGERACC_ERROR"
    }),

    bacts() {
      if (this.bankaccs) {
        let baccs = this.bankaccs.map(b => {
          return {
            bname: b.bank_name + " (" + b.acc_num + ")",
            ...b
          };
        });

        return baccs;
      }

      return [];
    },


  },
  methods: {
    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },

    sumpayments(val) {
      let c = val.reduce((sum, payment) => {
        return sum + parseFloat(payment.amount);
      }, 0);

      return c ? c : 0;
    },
    //Bank Transactions crud begin
    log(c) {
      console.log(c);
    },
    addbanktran() {
      this.$store.dispatch("banktrans/add", this.banktran_model);

      if (this.bterrors == null) {
        this.$toast.success("Bank Transaction added successfully");

        this.banktran_model = {
          bankacc_id: "",
          tran_type: "",
          description: "",
          amount: "",
          tdate: new Date().toISOString().substr(0, 10)
        };

        setTimeout(() => {
          this.$store.dispatch("bankaccs/getAll");
        }, 1000);
      }
    },
    deletebanktran(banktran, index) {
      if (confirm("Are you sure you want to delete this bank transaction?")) {
        this.$store.dispatch("banktrans/delete", { banktran, index });

        this.$toast.success("Bank Transaction deleted successfully");

        setTimeout(() => {
          this.$store.dispatch("bankaccs/getAll");
        }, 1000);
      }
    },

    editbanktran(banktran) {
      this.editedIndex = this.banktrans.indexOf(banktran);
      this.banktran_model = Object.assign({}, banktran);

      //alert(this.editedIndex)

      this.showBt=true
    },
    updatebanktran(banktran, index) {
      this.$store.dispatch("banktrans/update", { index, banktran });

      if (this.bterrors == null) {
        this.editedIndex = -1;

        this.$toast.success("Bank Transaction updated successfully");

        this.banktran_model = {
          bankacc_id: "",
          tran_type: "",
          description: "",
          amount: "",
          tdate: new Date().toISOString().substr(0, 10)
        };

        this.showBt=false
        //this.$store.dispatch("banktrans/getAll", { type: 1 });

        //  setTimeout(()=>{
        //    window.location.reload();
        //  },100)
      } else {
        this.$toast.error(
          "Sorry, an error occured and bank transaction could not be updated."
        );
      }
    },
    savebanktran() {
      if (!this.$refs.form1.validate()) {
        return;
      }
      //decides between editing banktran info or saving banktran info
      if (this.editedIndex > -1) {
        this.updatebanktran(this.banktran_model, this.editedIndex);
      } else {
        this.addbanktran();
      }
    },
    //Bank Transactions crud end

    //Bank Accounts crud begins
    addbankacc() {
      this.$store.dispatch("bankaccs/add", this.bankacc_model);

      if (this.baerrors == null) {
        this.$toast.success("Bank Account added successfully");

        this.bankacc_model = {
          bank_name: "",
          bank_contact: "",
          acc_name: "",
          acc_num: "",
          acc_type: "",
          balance: ""
        };

        //this.$store.dispatch("bankaccs/getAll");
      }
    },
    deletebankacc(bankacc, index) {
      if (confirm("Are you sure you want to delete this bank account?")) {
        this.$store.dispatch("bankaccs/delete", { bankacc, index });

        if (this.baerrors == null) {
          this.$toast.success("Banktran deleted successfully");
          //this.$store.dispatch("bankaccs/getAll");
        } else {
          this.$toast.error(
            "Sorry an error occured and bank account could not be deleted"
          );
        }
      }
    },

    editbankacc(bankacc) {
      this.editedIndex = this.bankaccs.indexOf(bankacc);
      this.bankacc_model = Object.assign({}, bankacc);

      //alert(this.editedIndex)

      this.showBa=true
    },
    updatebankacc(bankacc, index) {
      this.$store.dispatch("bankaccs/update", { index, bankacc });

      if (this.baerrors == null) {
        this.editedIndex = -1;
        this.showB = false;
        this.$toast.success("Bank Account updated successfully");

        this.bankacc_model = {
          bank_name: "",
          bank_contact: "",
          acc_name: "",
          acc_num: "",
          acc_type: "",
          balance: ""
        };

        //this.$store.dispatch("bankaccs/getAll");

        this.showBa=false
        //this.$store.dispatch("banktrans/getAll", { type: 1 });

        //  setTimeout(()=>{
        //    window.location.reload();
        //  },100)
      } else {
        this.$toast.error(
          "Sorry, an error occured and bank account data could not be updated."
        );
      }
    },
    savebankacc() {
      if (!this.$refs.form2.validate()) {
        return;
      }
      //decides between editing banktran info or saving banktran info
      if (this.editedIndex > -1) {
        this.updatebankacc(this.bankacc_model, this.editedIndex);
      } else {
        this.addbankacc();
      }
    },

    //Bank Accounts crud ends

  },
  watch: {

    "banktran_model.cep": function(val) {
      if (val == false) {
        this.banktran_model.expacc = "";
      }
    },
    "banktran_model.tran_type": function(val) {
      if (val == "credit") {
        this.banktran_model.cep = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/banking/banking.vue